import React, { Component } from 'react'
import { auth } from './firebase'
import './login.css'
import './styles/title.css'
import './styles/subtitle.css'
import './styles/inputs.css'
import './styles/button.css'
import './styles/error-message.css'
import {Link} from 'react-router-dom'
import axios from 'axios'
import {discourse_url, firebase_url, courses_url, vanilla_url, env} from './config'

class Login extends Component {
  state = {
    isLoading: false,
    errorMessage: null,
    errorCode: null,
    email: '',
    password: '',
    loader: true,
    authLoader: false,
    page: 'community',
  };
  componentWillMount = () => {
    const { location } = this.props;
    const queryString = require('query-string');
    const qs = queryString.parse(location.search);
    this.setState({'page': qs['page']});
    // localStorage.setItem('coming_from', 'https://community.canopytax.com');
    if ('page' in qs && qs['page'] === 'courses') {
        console.log('setting redirect to courses');
        localStorage.setItem('coming_from', 'courses');
    }
    if ('page' in qs && qs['page'] === 'community') {
        localStorage.setItem('coming_from', 'community');
        console.log('has community');
    }
    if ('page' in qs && qs['page'] === 'vanilla') {
        localStorage.setItem('coming_from', 'vanilla');
    }
    if ('kind' in qs && 'message' in qs) {
      return this.setState({errorMessage: qs.message, errorCode: qs.kind, loader: false})
    }
    this.setState({doHandShake: true});
    let userHandler = auth.onAuthStateChanged(user => {
        if (user) {
            if ('sso' in qs && qs['sso'] !== localStorage.getItem('current_sso')) {
                localStorage.setItem('current_sso', qs['sso']);
                this.login(user);
            } else if ('page' in qs && (qs['page'] === 'courses' || qs['page'] === 'vanilla')) {
                this.login(user);
            } else {
                window.location = discourse_url + '/session/sso?return_path=/';
            }
        } else {
            console.log('not logged in');
            this.setState({loader: false});
        }
    });
    this.props.setUserHandler(userHandler)
  };
  login = user => {
      const { location } = this.props;
      const queryString = require('query-string');
      const qs = queryString.parse(location.search);
      if (!('sso' in qs) && 'page' in qs && qs['page'] === 'community') {
          console.log('sso not in qs');
          return;
      }
			this.setState({authLoader: true});
      auth.currentUser.getIdToken(true).then(token => {
          let params = {};
          if ('sso' in qs) {
              params['sso'] = btoa(qs['sso']);
          }
          if ('sig' in qs) {
              params['sig'] = btoa(qs['sig'])
          }
          params['page'] = localStorage.getItem('coming_from');
          let AuthStr = 'Bearer '.concat(token);
          axios.get(`${firebase_url}/login`,
              {params: params, headers: {Authorization: AuthStr}}).then(res => {
                let domain ='.canopytax.com';
                if (env === 'stage') {
                    domain = '.canopy.ninja'
                }
                document.cookie = `AuthenticatedUser=${res.data.cpe}; domain=${domain}; path=/`;

                let redirecting_to = courses_url;
                if(localStorage.getItem('coming_from') === 'community') {
                  redirecting_to = res.data["discourse_url"];
                } else if(localStorage.getItem('coming_from') === 'vanilla') {
                  redirecting_to = vanilla_url.replace("{jwttoken}", res.data.cpe);
                }

                console.log('redirecting', redirecting_to);
                window.location = redirecting_to;
          }).catch(error => {
            console.log('An error happened with logging in');
            this.setState({ errorCode: error.code, errorMessage: error.message, authLoader: false, loader: false, isLoading: false});
          });
      });
      this.props.setUser(user);
  };
  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({errorMessage: null, errorCode: null, isLoading: true});
    auth.signInWithEmailAndPassword(this.state.email, this.state.password)
      .then(() => {
        localStorage.setItem('last_submitted_email', this.state.email);
      })
      .catch(error => {
        this.setState({ errorCode: error.code, errorMessage: error.message, authLoader: false, loader: false, isLoading: false});
    });
  };

  render() {
		if (this.state.authLoader) {
			return (<div className="loginBox">
        <p className="subtitle subtitle-loading">One moment while we log you in.</p>
      </div>
		)}
    if (this.state.loader) {
			return (<div className="loginBox">
				<p className="subtitle subtitle-loading">Loading.</p>
			</div>
    )}

    return (
      <div className="content__box">
        <form onSubmit={this.handleSubmit}>
          <h1 className="title">Welcome to {this.state.page === 'community' || this.state.page === 'vanilla' ? 'Community' : 'Courses'}</h1>
          <p className="subtitle">Please enter your email and password.</p>

          {
            this.state.errorCode && <div className="error-message"> {this.state.errorMessage} </div>
          }

          <div className="inputs">
            <div className="inputs__field-wrap">
              <input className="inputs__input" type="text" placeholder="Email address" name="email" value={this.state.email} onChange={evt => this.setState({ email: evt.target.value })} />
            </div>

            <div className="inputs__field-wrap">
              <input className="inputs__input" type="password" placeholder="Password" name="password" value={this.state.password} onChange={evt => this.setState({ password: evt.target.value })} />
            </div>

            <div className="inputs__field-wrap">
              <Link to="/forgot">Forgot your password?</Link>
            </div>
          </div>

          <div>
            <button className="button" onClick={this.handleSubmit} disabled={this.state.isLoading}>{this.state.isLoading ? 'Loading...' : 'Sign in'}</button>
          </div>
        </form>
      </div>)
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/login.js